// Breakpoints. Use inside a styled-components template: `${media.phone} { ... }`.
export const media = {
  phone: '@media (max-width: 36em)', // <= 576px
  tablet: '@media (max-width: 56em)', // <= 896px
  short: '@media (max-height: 500px)',
};

export default media;
